export const FETCH_LOCATION = 'locationPage/FETCH_LOCATION';
export const UPDATE_LOCATION = 'location/UPDATE';
